import React, { useState } from 'react';
import { RiCloseFill, RiMenu3Line } from '@remixicon/react';
import { useTranslation } from "react-i18next";
import LangSelector from './LangSelector';
import { trackEvent } from '../analytics/googleAnalytics';

const navLinks = [
    { href: '#works', target: 'works', labelKey: 'nav.testToday' },
    { href: '#products', target: 'products', labelKey: 'nav.products' },
    { href: '#partners', target: 'partners', labelKey: 'nav.partners' },
    { href: '#testimonials', target: 'testimonials', labelKey: 'nav.testimonials' },
    { href: '#downloads', target: 'downloads', labelKey: 'nav.releaseNotes' },
];

const logoSrc = 'https://sepm-bucket.s3.eu-west-3.amazonaws.com/SEPM+Logo+Rund.png';

const trackNavigationClick = (target) => {
    trackEvent('navigation_clicked', {
        target,
        location: 'navbar',
    });
};

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className='fixed top-0 left-0 right-0 z-50 px-3 py-3 md:px-6'>
            <div className='mx-auto flex max-w-7xl items-center justify-between rounded-2xl border border-white/20 bg-transparent px-4 py-2 text-StandardSEPM md:px-6'>
                <a href='#hero' className='flex items-center gap-3'>
                    <img src={logoSrc} alt='SEPM logo' className='h-12 w-auto object-contain sm:h-14' />
                    <div className='hidden sm:block'>
                        <p className='text-base font-semibold tracking-wide'>SEPM</p>
                        <p className='text-xs text-StandardSEPM/70'>{t('nav.tagline')}</p>
                    </div>
                </a>

                <div className='hidden items-center rounded-full border border-StandardSEPM/10 bg-white/55 px-2 py-2 shadow-sm backdrop-blur-md md:flex'>
                    {navLinks.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            onClick={() => trackNavigationClick(link.target)}
                            className='rounded-full px-4 py-2 text-sm font-medium text-StandardSEPM/80 transition-all duration-300 ease-out hover:-translate-y-0.5 hover:bg-white hover:text-StandardSEPM hover:shadow-[0_8px_20px_rgba(34,34,34,0.08)]'
                        >
                            {link.labelKey ? t(link.labelKey) : link.label}
                        </a>
                    ))}
                </div>

                <div className='hidden items-center gap-3 md:flex'>
                    <a
                        href='#downloads'
                        onClick={() => trackNavigationClick('downloads')}
                        className='rounded-full bg-StandardSEPM px-5 py-2.5 text-sm font-semibold text-white shadow-[0_10px_25px_rgba(205,93,72,0.28)] transition hover:-translate-y-0.5 hover:bg-[#cd5d48]'
                    >
                        {t('nav.download')}
                    </a>
                    <LangSelector />
                </div>

                <div className='md:hidden'>
                    <button
                        onClick={toggleMenu}
                        className='flex h-11 w-11 items-center justify-center rounded-xl border border-StandardSEPM/15 bg-white/70 text-StandardSEPM shadow-sm backdrop-blur-md transition hover:bg-StandardSEPM hover:text-white focus:outline-none'
                        aria-label={isOpen ? 'Close Menu' : 'Open Menu'}
                    >
                        {isOpen ? <RiCloseFill size={22} /> : <RiMenu3Line size={22} />}
                    </button>
                </div>
            </div>

            {isOpen && (
                <div className='mx-auto mt-3 max-w-7xl rounded-2xl border border-StandardSEPM/15 bg-white/85 p-4 shadow-[0_16px_45px_rgba(34,34,34,0.08)] backdrop-blur-xl md:hidden'>
                    <div className='flex flex-col gap-2'>
                        {navLinks.map((link) => (
                            <a
                                key={link.href}
                                href={link.href}
                                onClick={() => {
                                    trackNavigationClick(link.target);
                                    setIsOpen(false);
                                }}
                                className='rounded-xl px-4 py-3 text-sm font-medium text-StandardSEPM/85 transition-all duration-300 ease-out hover:translate-x-1 hover:bg-StandardSEPM/10 hover:text-StandardSEPM hover:shadow-sm'
                            >
                                {link.labelKey ? t(link.labelKey) : link.label}
                            </a>
                        ))}
                        <a
                            href='#downloads'
                            onClick={() => {
                                trackNavigationClick('downloads');
                                setIsOpen(false);
                            }}
                            className='mt-2 rounded-xl bg-StandardSEPM px-4 py-3 text-center text-sm font-semibold text-white transition hover:bg-[#cd5d48]'
                        >
                            {t('nav.download')}
                        </a>
                        <div className='pt-2'>
                            <LangSelector />
                        </div>
                    </div>
                </div>
            )}
        </nav>
    )
}

export default NavBar